import React from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect';

export default function checkPermission(level, id, action) {
  const selectState = createSelector(state => state, state => ({
    permission: state.Permission.permission,
    menuData: state.MenuData.client,
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath
  }));
  const { permission, menuData, clientPath, brandPath, marketPath } = useSelector(selectState);

  // if (marketPath && Object.keys(permission['markets'].length > 0)) {
  //   return permission['markets'][marketPath]?.permissionsWK.includes(action);
  // } else if (brandPath && Object.keys(permission['brands'].length > 0)) {
  //   return permission['brands'][brandPath]?.permissionsWK.includes(action);
  // } else if (clientPath && Object.keys(permission['clients'].length > 0)) {
  //   if (clientPath !== '1') {
  //     return permission['clients'][clientPath]?.permissionsWK.includes(action);
  //   } else {
  //     return permission['companies'][menuData._id]?.permissionsWK.includes(action);  
  //   }
  // } else if (menuData._id && Object.keys(permission['companies'].length > 0)) {
  //   return permission['companies'][menuData._id]?.permissionsWK.includes(action);
  // } else {
  //   return false;
  // }

  if (level === 'companies') {
    if (clientPath === '1') {
      return permission['clients'][menuData._id]?.permissionsWK.includes(action);
    } else {
      return permission['companies'][menuData._id]?.permissionsWK.includes(action);
    }
  } else if (level === 'clients') {
    return permission['clients'][menuData._id]?.permissionsWK.includes(action);
  } else if (level === 'brands') {
    return permission['brands'][brandPath]?.permissionsWK.includes(action);
  } else if (level === 'markets') {
    return permission['markets'][marketPath]?.permissionsWK.includes(action);
  }

}